import detectPassiveEvents from 'detect-passive-events';

export const passiveIfPossible = detectPassiveEvents.hasSupport ? {capture: false, passive: true} : false
